import Vue from 'vue'

export default Vue.extend({
  props: {
    pageType: {
      type: String,
      default: '',
    },
    voucherValue: {
      type: String,
      default: null,
    },
    hideBreadcrumb: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return this.getTitleDescriptionItems(
        (itemIndex) => `pages.${this.pageType}.items.item${itemIndex}.title`,
        (itemIndex, descriptionIndex) => `pages.${this.pageType}.items.item${itemIndex}.description${descriptionIndex === 0 ? '' : descriptionIndex.toString()}`,
        0,
      )
    },
  },
})
